import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

type AsideProps = {
  children: ReactNode;
} & FlexProps;

export const Aside = ({ children, ...rest }: AsideProps) => {
  return (
    <Flex as="aside" flexDir="column" align="center" {...rest}>
      {children}
    </Flex>
  );
};
